import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./components/auth/login/Login";
import RegisterPage from "./components/auth/register/Register";
import ForgotPassword from "./components/auth/forgot-password/ForgotPassword";
import VerifyOtp from "./components/auth/verify-otp/VerifyOtp";
import SuccessPassword from "./components/auth/SuccessPassword/SucccessPassword";
import SuccessRegister from "./components/auth/SuccessRegister/SuccessRegister";
import { ToastContainer } from "react-toastify";

import DashboardLayout from "./components/Dashboard/Layouts/DashboardLayout";
import Home from "./components/Dashboard/Pages/Home/Home";
import Leaderboard from "./components/Dashboard/Pages/Leaderboard/Leaderboard";
import Predictions from "./components/Dashboard/Pages/Predictions/Predictions";
import Settings from "./components/Dashboard/Pages/Settings/Settings";
import Profile from "./components/Dashboard/Pages/Profile/Profile";
import VerifyPasswordOtp from "./components/auth/verify-otp/VerifypasswordOtp";
import ResetPassword from "./components/auth/forgot-password/Resetpassword";
import ProtectedRoute from "./components/Dashboard/Routes/ProtectedRoute";
import PublicRoute from "./components/Dashboard/Routes/PublicRoute";
import UserProfile from "./components/Dashboard/Pages/Profile/UserProfile";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === "en" ? "ltr" : "rtl";
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute> 
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />

        <Route
          path="/verify-otp"
          element={
            <PublicRoute>
              <VerifyOtp />
            </PublicRoute>
          }
        />

        <Route
          path="/forgot-verify-otp"
          element={
            <PublicRoute>
              <VerifyPasswordOtp />
            </PublicRoute>
          }
        />

        <Route
          path="/forgot-password/reset"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />

        <Route path="/success-register" element={<SuccessRegister />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-verify-otp" element={<VerifyPasswordOtp />} />
        <Route path="/forgot-password/reset" element={<ResetPassword />} />
        <Route path="/success-password" element={<SuccessPassword />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Home />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="predictions" element={<Predictions />} />
          <Route path="profile" element={<Profile />} />
          <Route path="user/:userId" element={<UserProfile />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
      <ToastContainer autoClose={2000} />
    </div>
  );
}
export default App;
